import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {FinalBsiRoutingModule} from "./final-bsi-routing.module";
import {GlobalModule} from "../global/global.module";
import {FinalBsiComponent} from "./final-bsi.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GlobalModule,
    NgbModule,
    FinalBsiRoutingModule
  ],
  declarations: [
    FinalBsiComponent
  ]
})
export class FinalBsiModule {

}
